<template>
  <el-dialog
    :title="title"
    :visible.sync="isUpdateDynamicCronjob"
    width="650px"
    :before-close="handleClose"
    top="10vh"
    :close="handleClose"
    custom-class="modern-dialog"
    @open="handleOpen"
  >
    <div class="dialog-header-themed">
      <div class="themed-icon">
        <i :class="showDetail ? 'el-icon-monitor' : 'el-icon-edit'"></i>
      </div>
      <div class="themed-text">
        <h3>{{ title }}</h3>
        <p v-if="showDetail">Xem chi tiết thông số chu kỳ chạy và mô tả của Cronjob tự động.</p>
        <p v-else>Cập nhật thông số chu kỳ, khóa hoạt động và mô tả tác vụ tự động chạy.</p>
      </div>
    </div>

    <el-form
      :model="formData"
      :rules="rules"
      ref="formData"
      label-position="top"
      class="modern-dialog-form"
    >
      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-info"></i> Thông tin cơ bản</h4>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Tên hoạt động" prop="name">
              <el-input v-model="formData.name" :disabled="showDetail" placeholder="Tên hoạt động" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Mã hoạt động (Job Key)" prop="jobKey">
              <el-input v-model="formData.jobKey" :disabled="showDetail" placeholder="Khóa Job Key" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Loại cấu hình" prop="category">
              <el-select
                v-model="formData.category"
                :disabled="showDetail"
                placeholder="Chọn loại cấu hình"
                class="w-full"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-date"></i> Chu kỳ hoạt động</h4>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Thời gian hoạt động (Cron Expression)" prop="cronExpression">
              <el-input v-model="formData.cronExpression" :disabled="showDetail" placeholder="Biểu thức Cron" />
              <div class="cron-tip">
                <i class="el-icon-info"></i> Định dạng: #giây #phút #giờ #ngày_trong_tháng #tháng #ngày_trong_tuần
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="form-section">
        <h4 class="section-divider"><i class="el-icon-notebook-2"></i> Chi tiết mô tả</h4>
        <el-form-item label="" prop="description">
          <el-input v-model="formData.description" type="textarea" :rows="3" :disabled="showDetail" placeholder="Mô tả chức năng chi tiết..." />
        </el-form-item>
      </div>
    </el-form>

    <template #footer>
      <div class="dialog-footer-themed">
        <el-button type="danger" plain size="medium" icon="el-icon-circle-close" @click="handleClose">
          Đóng
        </el-button>
        <el-button v-if="!showDetail" type="success" size="medium" icon="el-icon-circle-check" :loading="loading" @click="handleUpload">
          Lưu lại
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import cronjobService from "@/services/CronjobService/CronjobService";

export default {
  name: "UpdateDynamicCronjobDialog",
  props: {
    isUpdateDynamicCronjob: {
      type: Boolean,
      default: false
    },
    showDetail: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: () => 0
    },
    categoryOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      title: "",
      formData: {
        id: 0,
        name: "",
        jobKey: "",
        cronExpression: "",
        description: "",
        category: ""
      },
      loading: false,
      rules: {
        name: [
          { required: true, message: "Tên hoạt động không được để trống", trigger: "change" }
        ],
        jobKey: [
          { required: true, message: "Mã hoạt động không được để trống", trigger: "change" }
        ],
        cronExpression: [
          { required: true, message: "Thời gian chạy không được để trống", trigger: "change" }
        ],
        category: [
          { required: true, message: "Loại cấu hình không được để trống", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    async handleOpen() {
      this.title = this.showDetail ? "Chi tiết cấu hình" : "Sửa cấu hình";
      this.formData.id = this.id;
      try {
        const response = await cronjobService.detailDynamicCronjob(this.formData.id);
        this.formData = response.data.data || {};
        if (!this.formData.category) {
          this.formData.category = "OTHER";
        }
      } catch (error) {
        console.error(error);
      }
    },
    handleClose() {
      this.$refs["formData"].resetFields();
      this.$emit("close");
    },
    handleUpload() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          this.loading = true;
          cronjobService.updateDynamicCronjob(this.formData)
            .then((res) => {
              if (res.data.data === true) {
                this.$message.success("Sửa cấu hình thành công");
                this.handleClose();
              } else {
                this.$message.error("Sửa cấu hình thất bại");
              }
            })
            .catch((err) => {
              this.$message.error(err.response?.data?.message || "Lỗi cập nhật cấu hình!");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss">
/* Modern styling for dialog headers and layouts */
.modern-dialog {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;

  .el-dialog__header {
    display: none; /* Custom header used instead */
  }

  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>

<style lang="scss" scoped>
.dialog-header-themed {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 28px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #fff;

  .themed-icon {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.25);
    font-size: 20px;
  }

  .themed-text {
    h3 {
      margin: 0 0 4px 0;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
    p {
      margin: 0;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.modern-dialog-form {
  padding: 24px 28px;
}

.form-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;

  .section-divider {
    margin: 0 0 16px 0;
    font-size: 13px;
    font-weight: 700;
    color: #3b82f6;
    display: flex;
    align-items: center;
    gap: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 8px;
  }
}

/deep/ .el-form-item {
  margin-bottom: 16px;

  .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding: 0 0 4px 0 !important;
    font-size: 13px;
  }
  
  .el-input__inner {
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    &:focus {
      border-color: #3b82f6;
    }
  }
  
  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner {
    background-color: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
    font-weight: 600;
    cursor: default;
  }
}

.cron-tip {
  font-size: 12px;
  color: #64748b;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
}

.dialog-footer-themed {
  padding: 16px 28px;
  background: #f1f5f9;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

.w-full {
  width: 100%;
}
</style>
